export const HIRING_FORM_MODE = Object.freeze({
  ADD: 'add' as const,
  EDIT: 'edit' as const,
});

export type HiringFormMode = (typeof HIRING_FORM_MODE)[keyof typeof HIRING_FORM_MODE];
